// Vendor imports
const Bluebird = require('bluebird')
// Shared imports
const { ExtendableError } = require('shared/error-utils')
// Client lib imports
const airbrake = require('client/lib/airbrake')

// Constants

const DEFAULT_EXTENSION_TIMEOUT = 100 //ms

// Error types

class MixExtensionNotInstalledError extends ExtendableError {
  constructor() {
    super('Mix Extension is not installed')
    this.name = 'MixExtensionNotInstalledError' // Preserve name after minifying
  }
}

// Exported functions

function isInstalled() {
  // `mixext` is in the global scope when the extension is installed.
  return typeof window === 'object' && Boolean(window.mixext)
}

function getReference() {
  if (!isInstalled()) {
    throw new MixExtensionNotInstalledError()
  }
  return window.mixext
}

async function call(fn, timeout = DEFAULT_EXTENSION_TIMEOUT) {
  const ext = getReference()
  try {
    return Bluebird.resolve(fn(ext))
    .timeout(timeout)
  } catch (err) {
    airbrake.notify(err)
    throw err
  }
}

async function clearUrlCache(urlId) {
  return call(ext => ext.clearUrlCache(urlId))
  .catch(() => {
    // Swallow the error and do nothing
  })
}

async function clearUrlStateCache(urlId) {
  return call(ext => ext.clearUrlStateCache(urlId))
  .catch(() => {
    // Swallow the error and do nothing
  })
}

async function clearUserCache() {
  return call(ext => ext.clearUserCache())
  .catch(() => {
    // Swallow the error and do nothing
  })
}

async function clearUserStateCache() {
  return call(ext => ext.clearUserStateCache())
  .catch(() => {
    // Swallow the error and do nothing
  })
}

async function filterDomain(domain) {
  return call(ext => ext.filterDomain(domain))
  .catch(() => {
    // Swallow the error and do nothing
  })
}

async function ping() {
  return call(ext => ext.ping())
  .catch(() => {
    // Swallow the error and do nothing
  })
}

async function showUrl(url, recState) {
  return call((ext => ext.showUrl(url, { recState })), 500)
}

// Exports

module.exports = {
  MixExtensionNotInstalledError,
  call,
  clearUrlCache,
  clearUrlStateCache,
  clearUserCache,
  clearUserStateCache,
  filterDomain,
  getReference,
  isInstalled,
  ping,
  showUrl
}
